import React from 'react';
import ReactDOM from 'react-dom/client';
import { RegionProvider } from './contexts/RegionContext';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <RegionProvider initialRegion="london">
    <AuthProvider>
      <SubscriptionProvider>
        <App />
      </SubscriptionProvider>
    </AuthProvider>
  </RegionProvider>
);